<template>
    <div class="d-flex">
        <div class="search">
            <i class="ico-search larger color-1"></i>
            <input class="m-0 p-0" type="text" @keyup="typing" placeholder="Search">
        </div>

        <advanced :table="table" :rows="rows"></advanced>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Advanced from '@/tools/search/AdvancedSearch'

    export default {
        props: {
            table: String,
        },
        data: function() {
            return {
                rows: null,
            }
        },
        created: function() {
            this.rows = [
                { 
                    title: 'Agents & Stuff',
                    filters: [
                        {
                            type: 'select',
                            placeholder: 'Select an agent',
                            model: 'agent',
                            table: 'agents',
                            label: 'name',
                            items: this.getAgents,
                        }
                    ]
                }
            ]
        },
        computed: {
            ...mapGetters([
                'getAgents' 
            ]),
        },
        methods: {
            ...mapActions([
                'searchByQuery'
            ]),
            typing: function(e) {
                this.searchByQuery(e.target.value.toLowerCase());
            }
        },
        components: {
            Advanced
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .search {
        padding: 0.5rem 0.75rem;
        
        > input {
            border: 0;
            background-color: transparent;
        }
    }
</style>


// WEBPACK FOOTER //
// Search.vue?c3bc0dd4